export const oldUserPlans = {
  FREE: 'free', // free
  PLUS: 'plus', // nime herfei or plus (new version), new pro
  PRO: 'pro', // herfei, new team
  ADVANCE: 'advance', // pishrafte / vip
  ENTERPRISE: 'enterprise', //sazmani / tejari
}

export const newUserPlans = {
  FREE: 'free',
  PRO: 'pro',
  TEAM: 'team',
  ENTERPRISE: 'enterprise',
  ON_PREMISE: 'on_premise',
}
